import { makeObservable } from "mobx"

export interface LogStrategy {
  info(...args: unknown[]): void
  warn(...args: unknown[]): void
  error(...args: unknown[]): void
}

export class ConsoleLogStrategy implements LogStrategy {
  info(...args: unknown[]): void {
    console.log(...args)
  }

  warn(...args: unknown[]): void {
    console.warn(...args)
  }

  error(...args: unknown[]): void {
    console.error(...args)
  }
}

export class LogStore {
  private logger: LogStrategy

  constructor(logger: LogStrategy = new ConsoleLogStrategy()) {
    this.logger = logger
    makeObservable(this, {})
  }

  info(...args: unknown[]): void {
    this.logger.info(...args)
  }

  warn(...args: unknown[]): void {
    this.logger.warn(...args)
  }

  error(...args: unknown[]): void {
    this.logger.error(...args)
  }

  setStrategy(strategy: LogStrategy): void {
    this.logger = strategy
  }
}
